var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUnlimitedBadgeFigma(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    preserveAspectRatio: "none",
    width: "100%",
    height: "100%",
    overflow: "visible",
    style: {
      display: "block"
    },
    viewBox: "0 0 16.5 16.5",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 633183"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rectangle 8955",
    d: "M12.0002 8.875L12.0002 4.50021C12.0002 2.42903 10.321 0.75 8.24984 0.75C6.17877 0.75 4.49974 2.42893 4.49974 4.5",
    stroke: "var(--stroke-0, white)",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle 8956",
    d: "M4.49984 7.625L4.49984 11.9998C4.49984 14.071 6.17897 15.75 8.25016 15.75C10.3212 15.75 12.0003 14.0711 12.0003 12",
    stroke: "var(--stroke-0, white)",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle 8957",
    d: "M8.875 4.49958L4.50021 4.49958C2.42903 4.49958 0.75 6.17877 0.75 8.24996C0.75 10.321 2.42887 12 4.49987 12",
    stroke: "var(--stroke-0, white)",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle 8958",
    d: "M7.625 12.0004L11.9998 12.0004C14.071 12.0004 15.75 10.3214 15.75 8.25017C15.75 6.17903 14.071 4.5 11.9999 4.5",
    stroke: "var(--stroke-0, white)",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnlimitedBadgeFigma);
export default __webpack_public_path__ + "static/media/unlimited-badge-figma.b394fa5caff89a7418a545e633766a63.svg";
export { ForwardRef as ReactComponent };